<template>
  <v-container fluid grid-list-xs class="bgInvestments sectDist">
    <v-row justify="center" class="text-center mr-0 sectDist mx-0 px-0 mt-0 pt-0">
      <v-col cols="12" md="5" class="my-4" v-show="!$vuetify.breakpoint.xs">
<v-carousel
  class="roundCard pa-2 sect hidden-xs-only rounded-xl elevation-8"
  max-width="750"
  height="500"
  cycle
  interval="6000"
  hide-delimiters
  hide-delimiter-background
  show-arrows-on-hover
  progress
  progress-color="red"
>
  <v-carousel-item
    v-for="(image, i) in images"
    :key="i"
    class="fill-height"
  >
    <v-img
      :src="image.src"
      cover
      class="fill-height"
      eager
      alt="Cursuri de înot Anastasya"
    >
      <!-- <div class="d-flex fill-height align-center justify-center bg-red-lighten-5">
        <div class="text-center">
          <v-progress-circular
            indeterminate
            color="red"
            size="80"
            width="8"
            class="mb-4"
          ></v-progress-circular>
          <p class="text-h5 red--text text--darken-2 font-weight-bold">Se încarcă...</p>
        </div>
      </div> -->
    </v-img>
  </v-carousel-item>
</v-carousel>


      </v-col>
      <v-col cols="12" offset-sm="1" sm="4" class="mt-10">
        <div class="subSection">
          <v-chip label class="red">
            <p class="mb-0 white--text">O noua cladire in curand</p>
          </v-chip>
        </div>
        <h1 class="mb-15 mt-4">
          Construim 
          pentru viitor
        </h1>
        <v-row justify="center">
          <v-col cols="12" md="5"  v-show="$vuetify.breakpoint.xs">
              <!-- Mobile screens (xs only) -->
<v-carousel
  class="hidden-sm-and-up mx-auto rounded-xl elevation-6"
  height="400"
  cycle
  interval="6000"
  hide-delimiters
  hide-delimiter-background
  show-arrows-on-hover
  progress
  progress-color="red"
>
  <v-carousel-item
    v-for="(image, i) in images"
    :key="i"
    class="fill-height"
  >
    <v-img
      :src="image.src"
      contain
      class="fill-height"
      eager
      alt="Cursuri de înot Anastasya"
    >
      <template v-slot:placeholder>
        <div class="d-flex fill-height align-center justify-center bg-blue-grey-lighten-4">
          <div class="text-center">
            <v-progress-circular
              indeterminate
              color="red"
              size="64"
              width="6"
              class="mb-4"
            ></v-progress-circular>
            <p class="text-h6 white--text font-weight-medium">Se încarcă...</p>
          </div>
        </div>
      </template>
    </v-img>
  </v-carousel-item>
</v-carousel>
         
          </v-col>
          <v-col cols="6" :class="item.classOuter" v-for="(item, i) of items" :key="i" class="pa-0">
            <v-card :color="item.color" class="mr-0" elevation="0" height="120px">
              <v-container grid-list-xs fill-height>
                <v-row align-center justify="center">
                  <h2 class="white--text" style="line-height: 1.1em">
                    {{ item.title }}
                  </h2>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Investments",

  data: () => ({
          images: [
        { src: require('../assets/cladire/cladire1.jpeg') },
        { src: require('../assets/cladire/cladire2.jpeg') },
        { src: require('../assets/cladire/cladire3.jpeg') },
        { src: require('../assets/cladire/cladire4.jpeg') },
      ],
    items: [
      {
        color: "red",
        classOuter: "boxRedOuter",
        title: "960 mp",
      },
      {
        color: "blue",
        classOuter: "boxBlueOuter",
        title: "I-VIII",
      },
      {
        color: "lightPurple",
        classOuter: " boxLightPurpleOuter",
        title: "Sala de sport",
      },
      {
        color: " orange",
        classOuter: "boxOrangeOuter",
        title: "Capacitate  128 locuri",
      },
    ],
  }),
};
</script>
<style scoped>
.cardOpacity {
  opacity: 0.6;
}

.bgInvestments {
  background-image: url("../assets/slides/Slide4.jpg");
  width: 100%;
  min-height: 100vh;
  background-size: cover;
}

.roundCard {
  border-radius: 200px;
}
</style>
